const baseStyle = {
  px: { base: '4', sm: '6', md: '8', '2xl': '4' },
};

export default {
  baseStyle,
};
